module.exports = __webpack_public_path__ + "static/media/LinkMarketing.755d8350.svg";